import { gql } from "@apollo/client";

export const DISCOUNT_CODES = gql`
  query DiscountCodes(
    $where: DiscountCodeWhereInput
    $like: DiscountCodeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    discountCodes(
      where: $where
      like: $like
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      data {
        id
        code
        tariffKey
        label
        active
        startDate
        endDate
        process {
          id
          name
        }
      }
      count
    }
  }
`;

export const DISCOUNT_CODE = gql`
  query DiscountCode($where: DiscountCodeWhereInput) {
    discountCode(where: $where) {
      id
      code
      tariffKey
      label
      active
      startDate
      endDate
      process {
        id
        name
      }
    }
  }
`;

const discountCodes = { DISCOUNT_CODES, DISCOUNT_CODE };

export default discountCodes;
